<div *ngIf="isVisible" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity" (click)="closeModal()"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto" (click)="closeModal()">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-2xl bg-white dark:bg-[#1e2557] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg" (click)="$event.stopPropagation()">

        <!-- Close button -->
        <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
          <button type="button" (click)="closeModal()" class="rounded-md bg-white dark:bg-transparent text-gray-400 hover:text-gray-500 focus:outline-none">
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="px-6 py-5">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-5">Edit Contacts</h3>

          <!-- Emails Section -->
          <div class="mb-6">
            <h4 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
              </svg>
              Emails
            </h4>

            <!-- Email list -->
            <div class="space-y-2 mb-3">
              <div *ngFor="let email of editEmails; index as i"
                   class="flex items-center justify-between flex-1 bg-gray-50 dark:bg-[#252c5f] rounded-lg px-3 py-2">
                <span class="text-sm text-gray-700 dark:text-gray-300 break-all">{{ email }}</span>
                <button type="button" (click)="removeEmail(i)"
                        matTooltip="Delete"
                        matTooltipPosition="above"
                        class="ml-2 flex-shrink-0 text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 transition-colors">
                  <span class="sr-only">Remove email</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                    <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
              <div *ngIf="editEmails.length === 0" class="text-sm text-gray-400 dark:text-gray-500 py-1">
                No emails added.
              </div>
            </div>

            <!-- Add email input -->
            <div>
              <div class="flex items-center gap-2">
                <input type="email"
                       [(ngModel)]="newEmail"
                       (keydown.enter)="addEmail()"
                       (input)="emailError = ''"
                       placeholder="Add email address"
                       [class.ring-red-300]="emailError"
                       class="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-white dark:bg-[#252c5f] shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-[#3c4377] placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6">
                <button type="button" (click)="addEmail()"
                        matTooltip="Add"
                        matTooltipPosition="above"
                        class="flex-shrink-0 rounded-full bg-primary p-1.5 text-white hover:bg-opacity-90 transition-colors">
                  <span class="sr-only">Add email</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                    <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                  </svg>
                </button>
              </div>
              <p *ngIf="emailError" class="mt-1 text-xs text-red-500">{{ emailError }}</p>
            </div>
          </div>

          <!-- Phone Numbers Section -->
          <div class="mb-2">
            <h4 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
              </svg>
              Phone Numbers
            </h4>

            <!-- Phone list -->
            <div class="space-y-2 mb-3">
              <div *ngFor="let phone of editPhoneNumbers; index as i"
                   class="flex items-center justify-between flex-1 bg-gray-50 dark:bg-[#252c5f] rounded-lg px-3 py-2">
                <span class="text-sm text-gray-700 dark:text-gray-300">{{ phone }}</span>
                <button type="button" (click)="removePhone(i)"
                        matTooltip="Delete"
                        matTooltipPosition="above"
                        class="ml-2 flex-shrink-0 text-gray-400 hover:text-red-500 dark:text-gray-500 dark:hover:text-red-400 transition-colors">
                  <span class="sr-only">Remove phone number</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                    <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
              <div *ngIf="editPhoneNumbers.length === 0" class="text-sm text-gray-400 dark:text-gray-500 py-1">
                No phone numbers added.
              </div>
            </div>

            <!-- Add phone input -->
            <div>
              <div class="flex items-center gap-2">
                <input type="tel"
                       [(ngModel)]="newPhone"
                       (keydown.enter)="addPhone()"
                       (input)="phoneError = ''"
                       placeholder="Add phone number"
                       [class.ring-red-300]="phoneError"
                       class="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-white dark:bg-[#252c5f] shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-[#3c4377] placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6">
                <button type="button" (click)="addPhone()"
                        matTooltip="Add"
                        matTooltipPosition="above"
                        class="flex-shrink-0 rounded-full bg-primary p-1.5 text-white hover:bg-opacity-90 transition-colors">
                  <span class="sr-only">Add phone number</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                    <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                  </svg>
                </button>
              </div>
              <p *ngIf="phoneError" class="mt-1 text-xs text-red-500">{{ phoneError }}</p>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="bg-gray-50 dark:bg-[#1a2048] px-6 py-3 sm:flex sm:flex-row-reverse">
          <button type="button" (click)="save()" [disabled]="loading$ | async"
                  class="inline-flex w-full justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-90 sm:ml-3 sm:w-auto">
            {{ (loading$ | async) ? 'Saving...' : 'Save' }}
          </button>
          <button type="button" (click)="closeModal()" [disabled]="loading$ | async"
                  class="mt-3 inline-flex w-full justify-center rounded-md bg-white dark:bg-[#252c5f] px-4 py-2 text-sm font-semibold text-gray-900 dark:text-white shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-[#3c4377] hover:bg-gray-50 dark:hover:bg-[#2a3168] sm:mt-0 sm:w-auto">
            Cancel
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
